var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"user-create","title":"Mitarbeiter erstellen","width":800}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('user-form',{attrs:{"user":_vm.user,"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }